export const productEnum = {
	"DF":{
		name:"Funpera Standard",
		tag:"Standard",
		tagBg:"#5A6DFF",
		amount:"50000",
		productBg:require("./img/dfBg.png"),
		tips:"Auto‑unlock with timely repayments"
	},
	"DFVIP":{
		name:"Funpera VIP",
		tag:"Exclusive",
		tagBg:"#FFAA5A",
		amount:"50000",
		productBg:require("./img/vipBg.png"),
		tips:"This product will auto‑unlock after 3 good repayments."
	},
	"DFEP":{
		name:"Installment plan",
		tag:"PLATINUM",
		tagBg:"#F06400",
		amount:"60000",
		productBg:require("./img/epBg.png"),
		tips:"Maintain good repayment to auto‑unlock this product."
	}
}

export const productOptions = [
	{
		productType:"DF",
		name:"Funpera Standard",
		tag:"Standard",
		tagBg:"#5A6DFF",
		amount:"50000",
		tips:"Auto‑unlock with timely repayments"
	},
	{
		productType:"DFVIP",
		name:"Funpera VIP",
		tag:"Exclusive",
		tagBg:"#FFAA5A",
		amount:"50000",
		tips:"This product will auto‑unlock after 3 good repayments."
	},
	{
		productType:"DFEP",
		name:"Installment plan",
		tag:"PLATINUM",
		tagBg:"#F06400",
		amount:"60000",
		tips:"Maintain good repayment to auto‑unlock this product."
	}
]
